import convertUnits from 'Functions/convert-units'

/* ---------------------------------------------------- */
/* Checks if CSS worked or not                          */
/* ---------------------------------------------------- */
export default function isCssRuleApplied( cssProperty, current ) {
	// Worked?
	let worked = false

	// Variables
	let computedValue, color, shadow, fullWidth

	// Each all selected element and check if need to use important.
	window.Stylist.iDocJQ.find( ".stlst-selected,.stlst-selected-others" ).each( function() {
		computedValue = jQuery( this ).css( cssProperty )
		// @note: there is problem with line-height.
		// https://stackoverflow.com/questions/34129551/jquery-and-line-height
		// .css will ALWAYS return value in pixels
		// There are some checks bellow trying to slove this problem.

		// =====================================================================
		// Prepare/convert computed value.
		// If current value not undefined
		if ( window.stlst_legacy.isDefined( computedValue ) ) {
			// Convert Hex colors to RGB format
			computedValue = computedValue.replace( /#[0-9A-Fa-f]{6}/g, function( v ) {
				return window.stlst_legacy.hex_to_rgb( v )
			} ).replace( /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/g, function( v ) {
				return v.replace( /\s/g, '' )
			} )

			// Replace url() suffix/preffix.
			if ( 'background-image' === cssProperty ||
					'list-style-image' === cssProperty ) {
				computedValue = computedValue.replace( /"/g, "" ).replace( /'/g, "" ).replace( /url\(/g, "" ).replace( /\)/g, "" );
				current = current.replace( /"/g, "" ).replace( /'/g, "" ).replace( /url\(/g, "" ).replace( /\)/g, "" );
			}

			// Convert values to the same unit.
			if ( 'string' === typeof current && current.includes( 'em' ) ) {
				if ( 'string' === typeof computedValue && computedValue.includes( 'px' ) ) {
					current = convertUnits( {
						valueToCovert: current,
						unitFrom: 'em',
						unitInto: 'px',
						cssProperty: cssProperty,
					} )

					// Limit number precision to 2 symbols after floating point.
					current = parseFloat( current ).toFixed( 2 ) + 'px'
					computedValue = parseFloat( computedValue ).toFixed( 2 ) + 'px'
				}
			}

			// move color to the end
			if ( computedValue.indexOf( "rgb" ) != -1 && cssProperty == 'box-shadow' ) {
				color = computedValue.match( /rgb(.*?)\((.*?)\)/g ).toString()
				shadow = computedValue.replace( /rgb(.*?)\((.*?)\)/g, "" )
				computedValue = shadow + " " + color
			}

			if ( cssProperty == 'box-shadow' ) {
				computedValue = computedValue.replace( 'inset', '' )
				computedValue = computedValue.replace( /\s+/g, ' ' )
			}

			// Clean
			computedValue = jQuery.trim( computedValue )
		}

		// Replace inset
		if ( 'box-shadow' === cssProperty ) {
			current = current.replace( 'inset', '' )
		}

		// Convert Hex colors to RGB format
		if ( typeof current === 'string' ) {
			current = current.replace( /#[0-9A-Fa-f]{6}/g, function( v ) {
				return window.stlst_legacy.hex_to_rgb( v )
			} ).replace( /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/g, function( v ) {
				return v.replace( /\s/g, '' );
			} )
		}

		// Prepare font names.
		if ( 'font-family' === cssProperty ) {
			// Replace quotes in the font names.
			computedValue = computedValue.replace( /\'/g, '' ).replace( /\"/g, '' )
			current = current.replace( /\'/g, '' ).replace( /\"/g, '' )

			// Extract only first Font Name form the list.
			if ( -1 !== computedValue.indexOf( ',' ) ) {
				const computedValues = computedValue.split( ',' )
				computedValue = computedValues[ 0 ].trim()
			}

			if ( -1 !== current.indexOf( ',' ) ) {
				const currentValues = current.split( ',' )
				current = currentValues[ 0 ].trim()
			}
		}

		// Clean
		current = jQuery.trim( current )

		// computedValue = computedValue + ''

		// 'string' === typeof computedValue &&
		// Change rgb(XXX,XXX,XXX) to rgba(XXX,XXX,XXX,1) fromat.
		if ( computedValue.indexOf( "rgba" ) === -1 ) {
			computedValue = computedValue.replace( ')', ',1)' )
			computedValue = computedValue.replace( 'rgb(', 'rgba(' )
		}
		// Change rgb(XXX,XXX,XXX) to rgba(XXX,XXX,XXX,1) fromat.
		if ( current.indexOf( "rgba" ) === -1 ) {
			current = current.replace( ')', ',1)' )
			current = current.replace( 'rgb(', 'rgba(' )
		}
		// Remove !important from the value, to make
		// rgb(209,112,245) equal to rgb(209,112,245)!important
		if ( current.indexOf( "!important" ) !== -1 ) {
			current = current.replace( '!important', '' )
		}

		// If date mean same thing: stop.
		if ( window.stlst_legacy.get_basic_id( current ) == 'length' && window.stlst_legacy.get_basic_id( computedValue ) == 'autoauto' ) {
			worked = true;
		}

		if ( window.stlst_legacy.get_basic_id( current ) == 'inherit' && window.stlst_legacy.get_basic_id( computedValue ) == 'normal' ) {
			worked = true;
		}

		if ( window.stlst_legacy.isUndefined( computedValue ) ) {
			worked = true;
		}

		// if value is same, stop.
		if ( current == computedValue && window.Stylist.iDocJQ.find( ".stlst-selected-others" ).length === 0 ) {
			worked = true;
		}

		// If font name included in any way - it is match.
		if ( 'font-family' === cssProperty ) {
			if ( computedValue === current || -1 !== current.indexOf( computedValue ) || -1 !== computedValue.indexOf( current ) ) {
				worked = true;
			}
		}

		if ( 'text-decoration' === cssProperty && computedValue.indexOf( current ) != -1 ) {
			worked = true;
		}

		// background position fix.
		if ( 'background-position' === cssProperty ) {
			if ( current == 'lefttop' && computedValue == '0%0%' ) {
				worked = true;
			}

			if ( current == 'leftcenter' && computedValue == '0%50%' ) {
				worked = true;
			}

			if ( current == 'leftbottom' && computedValue == '0%100%' ) {
				worked = true;
			}

			if ( current == 'righttop' && computedValue == '100%0%' ) {
				worked = true;
			}

			if ( current == 'rightcenter' && computedValue == '100%50%' ) {
				worked = true;
			}

			if ( current == 'rightbottom' && computedValue == '100%100%' ) {
				worked = true;
			}

			if ( current == 'centertop' && computedValue == '50%0%' ) {
				worked = true;
			}

			if ( current == 'centercenter' && computedValue == '50%50%' ) {
				worked = true;
			}

			if ( current == 'centercenter' && computedValue == '50%50%' ) {
				worked = true;
			}

			if ( current == 'centerbottom' && computedValue == '50%100%' ) {
				worked = true;
			}

			if ( current == 'centerbottom' && computedValue == '50%100%' ) {
				worked = true;
			}
		}

		// Check numeric values.
		// computedValue – is always in pixels
		// current - can be px, %, em, etc.
		if ( cssProperty === 'width' || cssProperty === 'min-width' || cssProperty === 'max-width'
			|| cssProperty === 'height' || cssProperty === 'min-height' || cssProperty === 'max-height'
			|| cssProperty === 'font-size' || cssProperty === 'line-height' || cssProperty === 'letter-spacing'
			|| cssProperty === 'word-spacing' || cssProperty === 'margin-top' || cssProperty === 'margin-left'
			|| cssProperty === 'margin-right' || cssProperty === 'margin-bottom' || cssProperty === 'padding-top'
			|| cssProperty === 'padding-left' || cssProperty === 'padding-right' || cssProperty === 'padding-bottom'
			|| cssProperty === 'border-width'
			|| cssProperty === 'border-left-width' || cssProperty === 'border-right-width'
			|| cssProperty === 'border-top-width' || cssProperty === 'border-bottom-width'
			|| cssProperty === 'border-top-left-radius' || cssProperty === 'border-top-right-radius'
			|| cssProperty === 'border-bottom-left-radius' || cssProperty === 'border-bottom-right-radius'
			|| cssProperty === 'opacity' || cssProperty === 'z-index'
			|| cssProperty === 'top' || cssProperty === 'left' || cssProperty === 'right' || cssProperty === 'bottom' ) {
			const currentValFormatted = window.stlst_legacy.number_filter( current.replace( /\.00$/g, "" ).replace( /\.0$/g, "" ) ),
				computedValueFormatted = window.stlst_legacy.number_filter( computedValue.replace( /\.00$/g, "" ).replace( /\.0$/g, "" ) )

			// If value is similar.
			if ( currentValFormatted !== '' &&
					currentValFormatted == computedValueFormatted ) {
				worked = true;
			}

			if ( cssProperty === 'min-height' &&
					mainBody.hasClass( "stlst-element-resizing" ) ) {
				worked = true;
			}

			if ( ( Math.round( parseFloat( current ) * 100 ) / 100 ) === ( Math.round( parseFloat( computedValue ) * 100 ) / 100 ) ) {
				worked = true;
			}

			// Browser always return computedValue in px format, custom check for %, em.
			if ( current.indexOf( "%" ) != -1 && computedValue.indexOf( "px" ) != -1 ) {
				window.stlst_legacy.get_selected_element().addClass( "stlst-full-width" );
				fullWidth = window.Stylist.iDocJQ.find( ".stlst-full-width" ).css( "width" );
				window.stlst_legacy.get_selected_element().removeClass( "stlst-full-width" );

				if ( ( parseInt( computedValue ) - ( parseInt( fullWidth ) * parseFloat( current ) / 100 ) ) < 1 ) {
					worked = true;
				}
			}

			// id, css, current
			// If line-height and current is number (not includes px,%,em,etc..)
			if ( 'line-height' === cssProperty && ! isNaN( current ) ) {
				// Calculate a proper line-height value based on font-size.
				const fontSize = jQuery( this ).css( 'font-size' )
				const computedLineHeight = parseInt( parseInt( computedValue ) / parseInt( fontSize.replace( 'px', '' ) ) );

				if ( parseInt( computedLineHeight ) == parseInt( current ) ) {
					worked = true;
				}
			}

			// smart important not available for em format
			if ( current.indexOf( "em" ) != -1 && computedValue.indexOf( "px" ) != -1 ) {
				worked = true;
			}
		}

		// not use important, If value is inherit.
		if ( current == "inherit" || current == "auto" ) {
			worked = true
		}

		// not worked? stop each.
		if ( worked === false ) {
			return false
		}
	} ) // Each end.

	return worked;
}




// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/is-css-rule-applied.js